module.exports = __webpack_public_path__ + "static/media/logout.9947d37d.svg";